"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFacetItemFromApi = void 0;
var _FilterOption = require("../components/FilterOption");
const getFacetItemFromApi = (facet)=>{
    if (!facet) {
        return {
            label: '',
            selected: false,
            value: '',
            type: _FilterOption.FilterOptionType.Default,
            count: 0
        };
    }
    var _facet_displayName, _facet_key;
    return {
        label: (_facet_displayName = facet.displayName) !== null && _facet_displayName !== void 0 ? _facet_displayName : '',
        selected: facet.active,
        value: (_facet_key = facet.key) !== null && _facet_key !== void 0 ? _facet_key : '',
        type: facet.facetInfo.color ? _FilterOption.FilterOptionType.Color : _FilterOption.FilterOptionType.Default,
        hexColors: facet.facetInfo.color ? [
            facet.facetInfo.color
        ] : undefined,
        count: facet.count
    };
};
exports.getFacetItemFromApi = getFacetItemFromApi;
